import { render, staticRenderFns } from "./v-work-list-item-details-popup.vue?vue&type=template&id=2002ae1b&scoped=true"
import script from "./v-work-list-item-details-popup.vue?vue&type=script&lang=js"
export * from "./v-work-list-item-details-popup.vue?vue&type=script&lang=js"
import style0 from "./v-work-list-item-details-popup.vue?vue&type=style&index=0&id=2002ae1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2002ae1b",
  null
  
)

export default component.exports